import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-community',
  templateUrl: './icon-community.component.html',
  styleUrls: ['./icon-community.component.scss']
})
export class IconCommunityComponent implements OnInit {

  @Input() cssClass = '';

  constructor() { }

  ngOnInit() {
  }

}
